/**
 * Deixa o texto comparável ignorando acentos e caixa, para que "metricas"
 * encontre "Métricas" (e vice-versa).
 *
 * NFD decompõe cada letra acentuada em letra + diacrítico combinante, e a regex
 * descarta esses diacríticos (faixa U+0300–U+036F).
 *
 * Use nos DOIS lados da comparação — no termo digitado e no texto alvo — senão
 * quem digita com acento deixa de encontrar itens escritos sem acento.
 */
export const normalizeText = (value: string): string =>
  (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
